<template>
	<header class="header">
		<button
			v-if="isVisible"
			:class="['hamburger', 'hamburger--spring', { 'is-active': isActive }]"
			@click="isActive = !isActive"
		>
			<span class="hamburger-box">
				<span class="hamburger-inner"></span>
			</span>
		</button>
		<h2 class="header__h2">
			Director of photography
		</h2>
		<h1 class="header__logo">
			MICHAŁ GRUSZCZYŃSKI
		</h1>
		<transition name="slide" mode="out-in">
			<nav
				v-if="isActive && !$store.getters['auth/isAdminPage']"
				class="phonemenu"
				ref="phonemenu"
			>
				<!--menu główne na ekrany mobilne-->
				<router-link to="/" active-class="underline" class="button" exact>
					ALL VIDEOS
				</router-link>
				<router-link to="/commercial" active-class="underline" class="button" exact>
					COMMERCIAL
				</router-link>
				<router-link
					to="/documentary"
					active-class="underline"
					class="button"
					exact
				>
					DOCUMENTARY
				</router-link>
				<router-link to="/music" active-class="underline" class="button" exact>
					MUSIC VIDEO
				</router-link>
				<router-link to="/narrative" active-class="underline" class="button" exact>
					NARRATIVE
				</router-link>
				<div class="phonelistitem"></div>
				<router-link to="/bio" active-class="underline" class="biobutton">
					BIO/RESUMÉ
				</router-link>
				<router-link
					v-if="$store.getters['project/data'].length > 0"
					to="/still"
					class="biobutton"
					active-class="underline"
				>
					STILL
				</router-link>
			</nav>
		</transition>

		<div class="menu2" ref="menu2"></div>
		<!--menu pomocnicze, do klejenia-->
		<nav v-if="!$store.getters['auth/isAdminPage']" class="menu" ref="menu">
			<!--menu główne-->
			<div class="firstmenu">
				<router-link to="/" active-class="underline" class="button" exact>
					ALL VIDEOS
				</router-link>
			</div>
			<div class="secondmenu">
				<router-link to="/commercial" active-class="underline" class="button" exact>
					COMMERCIAL
				</router-link>
				<router-link
					to="/documentary"
					active-class="underline"
					class="button"
					exact
				>
					DOCUMENTARY
				</router-link>
				<router-link to="/music" active-class="underline" class="button" exact>
					MUSIC VIDEO
				</router-link>
				<router-link to="/narrative" active-class="underline" class="button" exact>
					NARRATIVE
				</router-link>
			</div>
			<div class="thirdmenu">
				<a class="listitem"></a>
				<router-link to="/bio" class="biobutton" active-class="underline">
					BIO/RESUMÉ
				</router-link>
				<router-link
					v-if="$store.getters['project/data'].length > 0"
					to="/still"
					class="biobutton"
					active-class="underline"
				>
					STILL
				</router-link>
			</div>
		</nav>
		<nav v-else class="menu">
			<div class="secondmenu">
				<router-link
					to="/edit-movies"
					active-class="underline"
					class="button"
					exact
				>
					EDIT MOVIES
				</router-link>
				<router-link
					to="/edit-projects"
					active-class="underline"
					class="button"
					exact
				>
					EDIT PROJECTS
				</router-link>
			</div>
		</nav>
		<button
			v-if="$store.getters['auth/isAdminPage']"
			class="back"
			@click="logout"
		>
			{{ $t('buttons.logout') }}
		</button>
	</header>
</template>
<script>
export default {
	methods: {
		logout() {
			this.$store.dispatch('auth/signOut')
			this.$router.push('/')
		},
		scrollFunc() {
			if (this.$refs.menu) {
				this.scrolled = Math.max(
					window.pageYOffset,
					document.documentElement.scrollTop,
					document.body.scrollTop
				)

				if (
					this.scrolled > this.menuOffset &&
					this.$refs.menu.style.display !== 'none'
				) {
					this.$refs.menu.classList.add('sticky')
					this.$refs.menu2.classList.add('active')
				} else {
					this.$refs.menu.classList.remove('sticky')
					this.$refs.menu2.classList.remove('active')
				}
			}
		},
		resizeFunc() {
			if (window.innerWidth >= 760) {
				this.isActive = false
				this.isVisible = false
			} else {
				this.isVisible = true
			}
		}
	},
	data: () => ({
		menuOffset: 0,
		scrolled: 0,
		isActive: false,
		isVisible: false
	}),
	mounted() {
		if (this.$refs.menu) {
			window.addEventListener('scroll', this.scrollFunc)
			window.addEventListener('resize', this.resizeFunc)
			this.menuOffset = this.$refs.menu.offsetTop
		}
		if (window.innerWidth <= 760) {
			this.isVisible = true
		}
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.scrollFunc)
		window.removeEventListener('resize', this.resizeFunc)
	}
}
</script>
